module.exports = "/assets/data/c30d694dd8742bfcda1f068051bc187c-WD17.data.json";